import type { LOAN_REQUEST_OFFER_SOURCES } from 'cpool-constants';
import type { SchemaEuropaceOffer } from 'cpool-schemas';
import type {
    SchemaLoanRequestResolver_GetAcceptedOffers,
    SchemaLoanRequestResolver_GetOfferById,
} from 'cpool-tables/backend-resolvers';
import type { ValueOf } from 'cpool-utils';

export const REQUEST_HEADER_KINDS = {
    NEW_CREDIT_REQUEST: 'new credit request',
    REQUEST_HISTORY: 'request history',
} as const;

export type RequestHeaderKind = ValueOf<typeof REQUEST_HEADER_KINDS>;

export const REQUEST_HEADER_PATHS = {
    [REQUEST_HEADER_KINDS.NEW_CREDIT_REQUEST]: 'new-request',
    [REQUEST_HEADER_KINDS.REQUEST_HISTORY]: 'request-history',
} as const satisfies Record<RequestHeaderKind, string>;

export const REQUEST_HEADER_ROUTES = {
    [REQUEST_HEADER_KINDS.NEW_CREDIT_REQUEST]: `/leads/details/$leadId/bank-request/${
        REQUEST_HEADER_PATHS[REQUEST_HEADER_KINDS.NEW_CREDIT_REQUEST]
    }`,
    [REQUEST_HEADER_KINDS.REQUEST_HISTORY]: `/leads/details/$leadId/bank-request/${
        REQUEST_HEADER_PATHS[REQUEST_HEADER_KINDS.REQUEST_HISTORY]
    }`,
} as const satisfies Record<RequestHeaderKind, string>;

export const getRequestHeaderKindFromPathname = (pathname: string): RequestHeaderKind =>
    pathname.endsWith(`/${REQUEST_HEADER_PATHS[REQUEST_HEADER_KINDS.REQUEST_HISTORY]}`)
        ? REQUEST_HEADER_KINDS.REQUEST_HISTORY
        : REQUEST_HEADER_KINDS.NEW_CREDIT_REQUEST;

export type AcceptedOfferSource =
    | Extract<
          NonNullable<SchemaLoanRequestResolver_GetOfferById>,
          { source: typeof LOAN_REQUEST_OFFER_SOURCES.EUROPACE | typeof LOAN_REQUEST_OFFER_SOURCES.EUROPACE_SYNC }
      >
    | {
          source: typeof LOAN_REQUEST_OFFER_SOURCES.CONSORS;
          offer: Extract<
              SchemaLoanRequestResolver_GetAcceptedOffers[number],
              { source: typeof LOAN_REQUEST_OFFER_SOURCES.CONSORS }
          >;
      };

export type OfferSource = {
    source: typeof LOAN_REQUEST_OFFER_SOURCES.EUROPACE;
    offer: SchemaEuropaceOffer;
};

export type SourceTypeObject = {
    [K in keyof Pick<typeof LOAN_REQUEST_OFFER_SOURCES, 'EUROPACE'>]: boolean;
};
